import {
  MovieService,
  MovieMetaService,
  RegionService,
  OrderService,
  PageService,
  EcomTrackingService,
  AuthService,
} from "hasta-la-vista-middleware-api/service";
import MetaData from "../../../mixins/meta-data.js";
import moment from "moment";
import DetailSessionCard from "@/components/cards/detailSessionCard";

export default {
  mixins: [MetaData],
  components: {
    DetailSessionCard,
  },
  data() {
    return {
      loading: true,
      locationData: null,
      formData: {
        cinema_id: null,
        experienceName: "2D",
        place_query: null,
        selected_time_range: null,
        experiences: [],
        cinema: {},
        experience: {},
      },
      subsCinemas: ["3001","6121","6451","5801","1691","1101","4201","4231","1351","5451","6101",],
      sessionData: {
        selectedSession: null,
        selectedDate: null,
      },
      selectedSessionDate: null,
      regionsRaW: [],
      cinemasNearBy: [],
      movie: null,
      truncAmount: 500,
      signUp: false,
      loadBooking: true,
      festival: null,
      place: "",
      previousCinemaID: null,
      movieCinemas: [],
      loadingContinue: false,
      cancelOrderLoad: false,
      showHandleGenericError: false,
      showHandleNoSeatsAvailableError: false,
      selected_types: [],
      selected_time: null,
      created: true,
      typesForCinemas: [],
      selected_cinema_id: [],
      selected_time_range: null,
      time_tags: [],
      type_groups: [],
      matching_time_tags: [],
      selectedSession: {
        id: null,
      },
      dateAndSessionOptionsForSelect: [],
      route_types: [],
      filteredCinemas: [],
      timeRanges: null,
      route_time_range: null,
      first_date_with_time: null,
      first_date_available: null,
      cinemasForTime: null,
      metaExperiences: null,
      first_date_set: false,
      second_date_set: false,
      selectedCinema: null,
      setSelectedType: false,
      selectedDateSet: null,
      user: null,
      guest: true,
      facebookPixelSKShow: false,
      facebookPixelWBShow: false,
      facebookPixelSWShow: false,
      titleSlugSet: false,
      covidConfirm: true,
      injected_movies: "{data:'none'}",
      injected_meta: "{data:'none'}",
      injected_regions: "{data:'none'}",
      injected_cinemas: "{data:'none'}",
      movie_id: null,
      movies: null,
      prerender: false,
      InjectFrontendURL: "https://www.sterkinekor.com",
      blackWidowFloodLightShow: false,
      redirectCinemas: [],
    }
  },

  computed: {
    regions() {
      this.route_types = [];

      if (this.cinemasForTime != null && this.cinemasForTime != undefined) {
        return [
          { name: "Nearby", cinemas: this.cinemasNearBy },
          {
            name: "Cinemas based on your filter",
            cinemas: this.cinemasForTime,
          },
        ].concat(this.regionsRaW);
      }

      return [{ name: "Nearby", cinemas: this.cinemasNearBy }].concat(
        this.regionsRaW
      );
    },

    selectedCinemaId() {
      if (this.formData.cinema_id) {
        this.selectedCinema = RegionService.getCinema(this.formData.cinema_id);
      }
      return this.formData.cinema_id ? this.formData.cinema_id : null;
    },

    sessionsForCinema() {
      return this.selectedCinemaId
        ? this.movie.cinemas[this.selectedCinemaId].filter((s) => {
            if (s.show_time != undefined && s.show_time != null) {
              return (
                !s.show_time.additional.is_passed &&
                (!this.festival || s.film_festival_id === this.festival.id)
              );
            } else {
              return false;
            }
          })
        : [];
    },
    experiencesForCinemas() {
      return this.movie && this.formData.cinema_id
        ? this.movie.getExperienceForCinema(this.formData.cinema_id)
        : [];
    },

    availableDates() {
      let avail = this.sessionsForCinema.reduce((c, session) => {
        if (session != undefined && session != null) {
          if (session.show_time != null && session.show_time != undefined) {
            if (
              session.show_time.additional != undefined &&
              session.show_time.additional != null
            ) {
              var obj = {
                string: `${session.show_time.additional.string_long_day_of_week} ${session.show_time.additional.string_nth_day} ${session.show_time.additional.string_long_month}`,
                show_time: session.show_time,
              };
              !~c.findIndex((c) => c.string === obj.string) && c.push(obj);
            }
          }
        }

        return c;
      }, []);

      // checking
      if (
        !this.sessionData.selectedDate &&
        avail != undefined &&
        avail != null
      ) {
        if (avail.length > 0) {
          this.setSelectedDate(moment(avail[0].show_time.date));
        }
      }

      if (this.$route.params.date) {
        if (avail && avail.length > 0) {
          let availableDates = [];

          for (var a = 0; a < avail.length; a++) {
            availableDates.push(
              avail[a].show_time.date.format("YYYY-MM-DD").toString()
            );
          }

          if (availableDates.indexOf(this.$route.params.date) > -1)
          {
            this.setSelectedDate(moment(this.$route.params.date));
          } else {
            this.setSelectedDate(moment(avail[0].show_time.date));
          }
        }
      }

      return avail;
    },

    availableSessions() {
      let sessions = [];

      sessions = this.sessionsForCinema.filter((session) => {
        if (
          session.show_time != undefined &&
          session.show_time != null &&
          this.sessionData != null &&
          this.sessionData != undefined
        ) {
          if (
            session.show_time.date != undefined &&
            session.show_time.date != null &&
            this.sessionData.selectedDate != null &&
            this.sessionData.selectedDate != undefined
          ) {
            if (
              session.show_time.date.format("YYYY-MM-DD") ===
              this.sessionData.selectedDate.format("YYYY-MM-DD")
            ) {
              return true;
            }

            return false;
          }
        }
      });

      return sessions;
    },

    hasSessionSelected() {
      return !!this.sessionData.selectedSession;
    },

    canBook() {
      return !!this.sessionData.selectedSession && this.covidConfirm;
    },

    previousPath() {
      let path = "";

      if (this.$route.params.cinema_id) {
        path += "/cinema/" + this.$route.params.cinema_id;
      }

      if (this.$route.params.types) {
        path += "/type/" + this.$route.params.types;
      }

      if (this.$route.params.date) {
        path += "/dates/" + this.$route.params.date;
      }

      return path !== "" ? path : "/";
    },
  },

  methods: {
    setUser() {
      AuthService.user().then((user) => {
        this.user = user;
        this.guest = user.isGuest();

        if (
          !user.isGuest() &&
          user.MembershipActivated === false &&
          this.first_time
        ) {
          this.cookieActive = false;
          this.showUserActivation = true;
          this.first_time = false;
        } else {
          this.showUserActivation = false;
        }
      });
    },

    truncToggle(el) {
      if (this.truncAmount < this.movie.synopsis.length) {
        this.truncAmount = this.movie.synopsis.length;
        el.innerHTML = "Read less";
      } else {
        this.truncAmount = 500;
        el.innerHTML = "Read more";
      }
    },

    getAsyncData() {
      this.metaTitle = this.movie.title;
      this.metaImage = this.movie.poster;
      this.metaDescription = this.movie.synopsis;
      this.metaCanonicalURL =
        "https://www.sterkinekor.com/details/" +
        this.movie.id +
        "/" +
        this.movie.title_slug;
      let og_url = document.querySelector('meta[name="og:url"]');
      og_url.content = this.metaCanonicalURL;

      let title_tag = document.querySelector('meta[name="title"]');
      title_tag.content = this.movie.title;

      let og_title_tag = document.querySelector('meta[name="og:title"]');
      og_title_tag.content = this.movie.title;

      if (this.movie != undefined && this.movie != null) {
        if (
          this.movie.opening_date != undefined &&
          this.movie.opening_date != null
        ) {
          this.schemaDataSrc = {
            "@context": "http://schema.org",
            "@type": "Movie",
            image: this.movie.poster,
            dateCreated:
              this.movie.opening_date.additional.year +
              "-" +
              this.movie.opening_date.additional.month +
              "-" +
              this.movie.opening_date.additional.day,
            description: this.movie.synopsis,
            name: this.movie.title,
          };
        }
      }
      this.$emit("updateHead");
    },

    placeSelected: function (place) {
      this.place = place;
      this.getClosestCinema("cinemas/:latitude/:longitude");
    },

    matchClosestCinemas(cinemasNearBy) {
      var matchedCineams = [];
      for (let i = 0; i < cinemasNearBy.length; i++) {
        for (let c = 0; c < this.movieCinemas.length; c++) {
          if (cinemasNearBy[i].id == this.movieCinemas[c]) {
            matchedCineams.push(cinemasNearBy[i]);
          }
        }
      }

      return matchedCineams;
    },

    getClosestCinema() {
      RegionService.getCinemasNearBy(
        this.place.latitude,
        this.place.longitude
      ).then((cinemasNearBy) => {
        Promise.resolve(this.matchClosestCinemas(cinemasNearBy)).then(
          (cinemas) => {
            if (cinemas != undefined) {
              this.cinemasNearBy = cinemas;
              this.cinemasNearBy.length = 5;
            }
          }
        );
      });
    },

    getStatus(session) {
      var status = true;
      if (session.seats_available <= 1) {
        status = false;
      }
      return status;
    },

    getStatusString(session) {
      var status = "";
      if (session.seats_available <= 1) {
        status = "Sold Out";
      } else if (session.seats_available <= 10) {
        status = "Limited Seats Available";
      }
      return status;
    },

    resetForm() {
      this.sessionData.selectedDate = null;
      this.sessionData.selectedSession = null;
    },

    setSelectedDateOnRender(date) {},

    setSelectedDate(date) {
      this.sessionData.selectedDate =
        this.sessionData.selectedDate === date ? null : date;
      this.selectedSessionDate = null;
      this.sessionData.selectedSession = null;
    },

    setSelectedSession(session) {
      if (this.getStatus(session)) {
        this.sessionData.selectedSession =
          this.sessionData.selectedSession === session ? null : session;
        this.startOrder();
      }
    },

    startOrder() {
      this.loading = true;
      window.scroll({ top: 0, left: 0 });

      OrderService.getSessionAvailableSeatCount(
        this.sessionData.selectedSession.id
      ).then((session) => {
        let data = session.data;

        if (data.SeatsAvailable != undefined && data.SeatsAvailable > 1) {
          OrderService.newOrder(
            this.sessionData.selectedSession.id,
            this.formData.cinema_id,
            this.$route.params.id
          ).then(
            (order) => {
              this.$router.push(
                `/booking/1${
                  this.festival ? "/film-festival/" + this.festival.nid : ""
                }`
              );
            },
            (error) => {
              this.showHandleGenericError = true;
            }
          );
        } else {
          this.showHandleNoSeatsAvailableError = true;
        }
      });
    },

    startDirectOrder(session_id, cinema_id, movie_id) {
      this.loading = true;
      window.scroll({ top: 0, left: 0 });

      OrderService.getSessionAvailableSeatCount(session_id).then((session) => {
        let data = session.data;

        if (data.SeatsAvailable != undefined && data.SeatsAvailable > 1) {
          OrderService.newOrder(session_id, cinema_id, movie_id).then(
            (order) => {
              this.$router.push(
                `/booking/1${
                  this.festival ? "/film-festival/" + this.festival.nid : ""
                }`
              );
            },
            (error) => {
              this.showHandleGenericError = true;
            }
          );
        } else {
          this.showHandleNoSeatsAvailableError = true;
        }
      });
    },

    toggleSignUp(signUp) {
      this.signUp = signUp[0];
    },

    relatedToMovie(elms, relatedEl, fieldToRelated) {
      let item = null;
      elms.forEach((el) => {
        if (el[fieldToRelated] == relatedEl.id) {
          item = el;
        }
        return item;
      });
    },

    getMovies() {
      this.loading = true;
      window.scroll({ top: 0, left: 0 });
      let cinema_slug = this.$route.params.cinema_id || null;

      return Promise.all([
        RegionService.getRegions(),
        MovieService.getMovieDetail(this.$route.params.id, true),
        RegionService.getCinemaBySlug(cinema_slug),
      ]).then(([regions, movieDetails, region]) => {
        this.formData.cinema = region;
        this.selectedCinema = region;
        window.scroll({ top: 0, left: 0 });
        this.movie = movieDetails.movie;

        EcomTrackingService.doDataLayerProductDetailView(this.movie);

        if (region) this.formData.cinema_id = region.id;
        else this.formData.cinema_id = 0;
        this.related_movies = movieDetails.related.filter(
          (m) => !m.coming_soon && m.id != this.movie.id
        );

        this.regionsRaW = regions.findByCinemas(
          Object.keys(this.movie.cinemas)
        );
        this.loading = false;
        // RICHARD:UPDATE since this seems to add behavior i made it happen after the loading lifecycle to prevent it holding up a booking

        this.getAsyncData();

        // calc srcsets
        if (this.movie.promo) {
          if (this.movie.promo.mobile_movie_detail_image) {
            this.movie.promo.srcsets =
              this.movie.promo.mobile_movie_detail_image +
              " 700w, " +
              this.movie.promo.movie_detail_image +
              " 2000w";
          } else {
            this.movie.promo.srcsets =
              this.movie.promo.movie_detail_image + " 2000w";
          }
        }

        return this.movie;
      });
    },

    backToMovie() {
      this.showTimeout = false;
      this.loadingContinue = true;
      OrderService.tearDown();
      this.showHandleGenericError = false;
      this.$router.go(this.$router.currentRoute);
    },

    goHome() {
      this.showTimeout = false;
      this.cancelOrderLoad = true;
      OrderService.tearDown();
      this.showHandleGenericError = false;
      this.$router.push("/");
    },

    generateTimeRanges(movies) {
      var time_tags = [];

      for (let m in movies) {
        for (let t in movies[m].time_tags) {
          time_tags.push(movies[m].time_tags[t]);
        }
      }

      var unique = [...new Set(time_tags)];
      var time_ranges = [];

      for (var i = 1; i <= 24; i++) {
        var hour = 0;
        var next_hour = 0;
        if (i < 10) {
          hour = "0" + i;
          if (i < 9) {
            next_hour = "0" + (i + 1);
          } else {
            next_hour = i + 1;
          }
        } else {
          hour = i;
          if (i == 23) {
            next_hour = "00";
          } else if (i == 24) {
            hour = "00";
            next_hour = "01";
          } else {
            next_hour = i + 1;
          }
        }

        let base_hour = i;

        let partial_time = hour + ":";
        var range = hour + ":00 - " + next_hour + ":00";
        var has_time_slot = false;

        for (let t in unique) {
          if (unique[t] != undefined && typeof unique[t] === "string") {
            if (unique[t].includes(partial_time)) {
              has_time_slot = true;
              break;
            }
          }
        }

        if (has_time_slot) {
          time_ranges.push({ range: range, hour: hour, base_hour: base_hour });
        }
      }

      let groups = this.generateRangeGroups(time_ranges);

      if (this.created) {
        let route_time = this.$route.params.time
          ? this.$route.params.time
          : null;

        for (let g in groups) {
          if (route_time == groups[g].id) {
            this.selected_time_range = groups[g];
          }
        }

        this.created = false;
      }

      let groupRanges = { name: "Time", items: groups };

      return groupRanges;
    },

    generateRangeGroups(time_ranges) {
      let groups = [
        {
          range: "9:00 to 10:00",
          id: "9am-10am",
          config_ranges: ["09:", "10:"],
          ranges: [],
        },
        {
          range: "11:30 to 12:30",
          id: "11:30am-12:30pm",
          config_ranges: ["11:", "12:"],
          ranges: [],
        },
        {
          range: "14:00 to 15:15",
          id: "2pm-3:15pm",
          config_ranges: ["14:", "15:"],
          ranges: [],
        },
        {
          range: "17:00 to 18:00",
          id: "5pm-6pm",
          config_ranges: ["17:", "18:"],
          ranges: [],
        },
        {
          range: "19:30 to 20:30",
          id: "7:30pm-8:30pm",
          config_ranges: ["19:", "20:"],
          ranges: [],
        },
        {
          range: "22:00 to 22:45",
          id: "10pm-10:45pm",
          config_ranges: ["22:"],
          ranges: [],
        },
      ];

      for (let t in time_ranges) {
        for (let g in groups) {
          for (let cr in groups[g].config_ranges) {
            if (groups[g].config_ranges[cr] == time_ranges[t].hour + ":") {
              groups[g].ranges.push(time_ranges[t]);
            }
          }
        }
      }

      return groups;
    },

    setOptionsFromRoute(movies) {
      if (this.route_types != undefined && this.route_types != null) {
        if (this.route_types.length > 0) {
          Promise.all([this.gettypesForCinemas()]).then(
            ([types_for_cinemas]) => {
              let cinema_type_selected_set = false;
              for (let tc in types_for_cinemas) {
                for (let i in types_for_cinemas[tc].items) {
                  for (let rt in this.route_types) {
                    for (let t in this.route_types[rt].types) {
                      if (
                        types_for_cinemas[tc].items[i].name ==
                        this.route_types[rt].types[t].name
                      ) {
                        if (!cinema_type_selected_set) {
                          cinema_type_selected_set = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          );
        }
      }
    },

    generateSelectedRouteCinemaTypes(route_types) {
      let selected_cinema_types = [];
      if (route_types && route_types != undefined && route_types != null) {
        if (route_types.length > 0) {
          for (let r in route_types) {
            selected_cinema_types.push({
              name: route_types[r].replace("-", " "),
            });
          }
        }
      }

      return selected_cinema_types;
    },

    gettypesForCinemas() {
      if (this.movie && this.formData.cinema_id) {
        let selectedType = null;
        return Promise.all([
          this.movie.getExperienceForCinema(this.formData.cinema_id),
          MovieMetaService.getMovieMeta(),
        ]).then(([experiences, meta]) => {
          let types = [];

          for (let e in experiences) {
            if (
              experiences[e] != undefined &&
              experiences[e] != null &&
              typeof experiences[e] == "string"
            ) {
              types.push({ name: experiences[e] });
            }
          }

          let route_type_list = [];

          if (
            this.route_types &&
            this.route_types != undefined &&
            this.route_types != null &&
            this.typesForCinemas != null &&
            this.typesForCinemas != undefined
          ) {
            Promise.all([
              MovieService.generateExperienceGroups(meta.experiences),
            ]).then(([groups]) => {
              let route_types = [];
              let set_route_types = [];

              if (
                this.$route.params.types != null &&
                this.$route.params.types != undefined
              ) {
                route_types = this.$route.params.types.split(",");

                for (let g in groups) {
                  for (let r in route_types) {
                    if (groups[g].name == route_types[r]) {
                      set_route_types.push(groups[g]);
                    }
                  }
                }
                this.route_types = set_route_types;
              }

              if (this.typesForCinemas.length > 0) {
                for (let tc in this.typesForCinemas) {
                  if (
                    this.typesForCinemas[tc] != undefined &&
                    this.typesForCinemas[tc] != null
                  ) {
                    for (let t in this.typesForCinemas[tc].items) {
                      if (
                        this.typesForCinemas[tc].items[t] != undefined &&
                        this.typesForCinemas[tc].items[t] != null
                      ) {
                        for (let rt in this.route_types) {
                          if (
                            this.route_types[rt] != undefined &&
                            this.route_types[rt] != null
                          ) {
                            for (let ty in this.route_types[rt].types) {
                              if (
                                this.route_types[rt].types[ty] != undefined &&
                                this.route_types[rt].types[ty] != null
                              ) {
                                let exists = false;
                                if (route_type_list.length > 0) {
                                  for (let rtl in route_type_list) {
                                    if (
                                      route_type_list[rtl] != undefined &&
                                      route_type_list[rtl] != null
                                    ) {
                                      if (
                                        route_type_list[rtl].name ==
                                        this.typesForCinemas[tc].items[t].name
                                      ) {
                                        exists = true;
                                      }
                                    }
                                  }
                                }

                                if (!exists) {
                                  route_type_list.push(
                                    this.typesForCinemas[tc].items[t]
                                  );
                                }

                                if (
                                  this.route_types[rt].types[ty].name ==
                                    this.typesForCinemas[tc].items[t].name &&
                                  selectedType == null
                                ) {
                                  selectedType =
                                    this.typesForCinemas[tc].items[t];
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              route_type_list = set_route_types;

              if (
                set_route_types &&
                set_route_types != undefined &&
                set_route_types != null
              ) {
                let typesBasedOnFilter = [];
                let otherTypes = [];

                if (types != undefined && types != null) {
                  if (types.length > 0) {
                    for (let tfc in types) {
                      if (types[tfc] != undefined && types[tfc] != null) {
                        if (
                          types[tfc].name != undefined &&
                          types[tfc].name != null &&
                          typeof types[tfc].name == "string"
                        ) {
                          for (let i in set_route_types) {
                            if (
                              set_route_types[i] != undefined &&
                              set_route_types[i] != null &&
                              typeof set_route_types[i] == "object"
                            ) {
                              for (let g in set_route_types[i].types) {
                                if (
                                  set_route_types[i].types[g].name ==
                                  types[tfc].name
                                ) {
                                  if (typeof types[tfc] == "object") {
                                    typesBasedOnFilter.push(types[tfc]);
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }

                if (
                  typesBasedOnFilter.length > 0 &&
                  types != undefined &&
                  types != null
                ) {
                  if (types.length > 0) {
                    for (let t in types) {
                      let inTypesBasedOnFilter = false;

                      if (types[t] != undefined && types[t] != null) {
                        for (let tf in typesBasedOnFilter) {
                          if (
                            typesBasedOnFilter[tf] != null &&
                            typesBasedOnFilter != undefined
                          ) {
                            if (types[t].name == typesBasedOnFilter[tf].name) {
                              inTypesBasedOnFilter = true;
                            }
                          }
                        }
                      }

                      if (!inTypesBasedOnFilter) {
                        if (typeof types[t] == "object") {
                          let exists = false;
                          if (otherTypes.length > 0) {
                            for (let ot in otherTypes) {
                              if (otherTypes[ot].name == types[t].name) {
                                exists = false;
                              }
                            }
                          }

                          if (!exists) {
                            otherTypes.push(types[t]);
                          }
                        }
                      }
                    }
                  }
                } else {
                  otherTypes = types;
                }

                if (
                  this.route_time_range &&
                  this.route_time_range != undefined &&
                  this.route_time_range != null
                ) {
                  let sessions = [];
                  let timeMatchedTypes = [];
                  let timeMatchedTypesOthers = [];
                  if (
                    this.movie.cinemas[this.formData.cinema_id] != undefined &&
                    this.movie.cinemas[this.formData.cinema_id] != null
                  ) {
                    sessions = this.movie.cinemas[this.formData.cinema_id];

                    if (sessions != undefined && sessions != null) {
                      if (sessions.length > 0) {
                        for (let s in sessions) {
                          if (
                            sessions[s].time_tag != undefined &&
                            sessions[s].time_tag != null &&
                            typeof sessions[s].time_tag == "string"
                          ) {
                            if (
                              this.route_time_range.config_ranges !=
                                undefined &&
                              this.route_time_range.config_ranges != null
                            ) {
                              for (let cr in this.route_time_range
                                .config_ranges) {
                                if (
                                  this.route_time_range.config_ranges[cr] !=
                                    undefined &&
                                  this.route_time_range.config_ranges[cr] !=
                                    null
                                ) {
                                  if (
                                    sessions[s].time_tag.includes(
                                      this.route_time_range.config_ranges[cr]
                                    )
                                  ) {
                                    if (
                                      route_type_list != null &&
                                      route_type_list != undefined &&
                                      route_type_list.length > 0
                                    ) {
                                      for (let rt in route_type_list) {
                                        if (
                                          route_type_list[rt] != undefined &&
                                          route_type_list[rt] != undefined
                                        ) {
                                          for (let rtt in route_type_list[rt]
                                            .types) {
                                            if (
                                              route_type_list[rt].types[rtt] !=
                                                undefined &&
                                              route_type_list[rt].types[rtt] !=
                                                undefined
                                            ) {
                                              for (let e in sessions[s]
                                                .experiences) {
                                                if (
                                                  sessions[s].experiences[e] !=
                                                    undefined &&
                                                  sessions[s].experiences[e] !=
                                                    null
                                                ) {
                                                  if (
                                                    route_type_list[rt].types[
                                                      rtt
                                                    ].name ==
                                                    sessions[s].experiences[e]
                                                      .name
                                                  ) {
                                                    timeMatchedTypes[
                                                      sessions[s].experiences[
                                                        e
                                                      ].name
                                                    ] =
                                                      sessions[s].experiences[
                                                        e
                                                      ];
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    } else {
                                      for (let e in sessions[s].experiences) {
                                        timeMatchedTypes[
                                          sessions[s].experiences[e].name
                                        ] = sessions[s].experiences[e];
                                      }
                                    }
                                  } else {
                                    for (let e in sessions[s].experiences) {
                                      let exists = false;
                                      if (timeMatchedTypesOthers.length > 0) {
                                        for (let tmo in timeMatchedTypesOthers) {
                                          if (
                                            timeMatchedTypesOthers[tmo].name ==
                                            sessions[s].experiences[e].name
                                          ) {
                                            exists = true;
                                          }
                                        }
                                      }

                                      if (!exists) {
                                        timeMatchedTypesOthers.push(
                                          sessions[s].experiences[e]
                                        );
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }

                        if (otherTypes.length > 0) {
                          for (let tmo in timeMatchedTypesOthers) {
                            let inOtherTypes = false;
                            for (let ot in otherTypes) {
                              if (
                                otherTypes[ot] != null &&
                                otherTypes[ot] != undefined &&
                                timeMatchedTypesOthers[tmo] != undefined &&
                                timeMatchedTypesOthers[tmo] != null
                              ) {
                                otherTypes[timeMatchedTypesOthers[tmo].name] =
                                  timeMatchedTypesOthers[tmo];
                              }
                            }

                            if (!inOtherTypes) {
                              let exists = false;
                              if (
                                typeof timeMatchedTypesOthers[tmo] ==
                                  "object" &&
                                timeMatchedTypesOthers[tmo] != null &&
                                timeMatchedTypesOthers[tmo] != undefined
                              ) {
                                for (let ot in otherTypes) {
                                  if (
                                    otherTypes[ot].name ==
                                    timeMatchedTypesOthers[tmo].name
                                  ) {
                                    exists = true;
                                  }
                                }

                                if (!exists) {
                                  otherTypes.push(timeMatchedTypesOthers[tmo]);
                                }
                              }
                            }
                          }
                        } else {
                          otherTypes = timeMatchedTypesOthers;
                        }

                        let typesByTimes = [];
                        let typesByTimesOther = [];

                        if (
                          typesBasedOnFilter != null &&
                          typesBasedOnFilter != undefined &&
                          otherTypes != undefined &&
                          otherTypes != null
                        ) {
                          for (let tmt in timeMatchedTypes) {
                            if (
                              timeMatchedTypes[tmt] != undefined &&
                              timeMatchedTypes[tmt] != null
                            ) {
                              for (let ot in otherTypes) {
                                if (
                                  otherTypes[ot] != undefined &&
                                  otherTypes[ot] != null
                                ) {
                                  if (
                                    timeMatchedTypes[tmt].name != undefined &&
                                    timeMatchedTypes[tmt].name != null &&
                                    typeof timeMatchedTypes[tmt].name ==
                                      "string"
                                  ) {
                                    if (
                                      otherTypes[ot].name != undefined &&
                                      otherTypes[ot].name != null &&
                                      typeof otherTypes[ot].name == "string"
                                    ) {
                                      if (
                                        timeMatchedTypes[tmt].name ==
                                        otherTypes[ot].name
                                      ) {
                                        typesByTimes[
                                          timeMatchedTypes[tmt].name
                                        ] = timeMatchedTypes[tmt];
                                      }
                                    }
                                  }
                                }
                              }

                              for (let ot in typesBasedOnFilter) {
                                if (
                                  typesBasedOnFilter[ot] != undefined &&
                                  typesBasedOnFilter[ot] != null
                                ) {
                                  if (
                                    timeMatchedTypes[tmt].name != undefined &&
                                    timeMatchedTypes[tmt].name != null &&
                                    typeof timeMatchedTypes[tmt].name ==
                                      "string"
                                  ) {
                                    if (
                                      typesBasedOnFilter[ot].name !=
                                        undefined &&
                                      typesBasedOnFilter[ot].name != null &&
                                      typeof typesBasedOnFilter[ot].name ==
                                        "string"
                                    ) {
                                      if (
                                        timeMatchedTypes[tmt].name ==
                                        typesBasedOnFilter[ot].name
                                      ) {
                                        if (
                                          typeof timeMatchedTypes[tmt] ==
                                          "object"
                                        ) {
                                          typesByTimes[
                                            timeMatchedTypes[tmt].name
                                          ] = timeMatchedTypes[tmt];
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }

                          let typesOther = [];
                          let availableTypes = [];

                          if (otherTypes.length > 0) {
                            for (let ot in otherTypes) {
                              let inAvailable = false;

                              for (let tbt in typesByTimes) {
                                if (
                                  typesByTimes[tbt] != null &&
                                  typesByTimes[tbt] != undefined &&
                                  otherTypes[ot] != undefined &&
                                  otherTypes[ot] != null
                                ) {
                                  if (
                                    typesByTimes[tbt].name ==
                                    otherTypes[ot].name
                                  ) {
                                    inAvailable = true;
                                  }
                                }
                              }

                              if (!inAvailable) {
                                typesOther.push(otherTypes[ot]);
                              }
                            }

                            otherTypes = typesOther;
                          }

                          for (let tbt in typesByTimes) {
                            if (typeof typesByTimes[tbt] == "object") {
                              availableTypes.push(typesByTimes[tbt]);
                            }
                          }

                          typesBasedOnFilter = availableTypes;
                        }
                      }
                    }
                  }
                }

                //remove duplicates
                let cleanOthers = [];
                let cleanFiltered = [];

                if (otherTypes.length > 0) {
                  for (let ot in otherTypes) {
                    let exists = false;
                    if (cleanOthers.length > 0) {
                      for (let co in cleanOthers) {
                        if (cleanOthers[co].name == otherTypes[ot].name) {
                          exists = true;
                        }
                      }
                    }

                    if (!exists) {
                      if (typeof otherTypes[ot] == "object") {
                        cleanOthers.push(otherTypes[ot]);
                      }
                    }
                  }

                  otherTypes = cleanOthers;
                }

                if (typesBasedOnFilter.length > 0) {
                  for (let tf in typesBasedOnFilter) {
                    let exists = false;

                    if (cleanFiltered.length > 0) {
                      for (let cf in cleanFiltered) {
                        if (
                          cleanFiltered[cf].name == typesBasedOnFilter[tf].name
                        ) {
                          exists = true;
                        }
                      }
                    }

                    if (!exists) {
                      if (typeof typesBasedOnFilter[tf] == "object") {
                        cleanFiltered.push(typesBasedOnFilter[tf]);
                      }
                    }
                  }

                  typesBasedOnFilter = cleanFiltered;
                }

                this.typesForCinemas = [
                  {
                    name: "Cinema types based on filter",
                    items: typesBasedOnFilter,
                  },
                  { name: "Other cinema types", items: otherTypes },
                ];
                return this.typesForCinemas;
              }
            });
          }

          this.typesForCinemas = [{ name: "Cinema Types", items: types }];
          return this.typesForCinemas;
        });
        // unused var??
        this.setSelectedType = true;
      } else {
        this.typesForCinemas = [];
        return [];
      }
    },

    getSessionsForCinema() {
      this.Movie;
    },

    getDatesForCinemaType() {
      Promise.resolve(MovieService.getMovies()).then((movies) => {
        Promise.resolve(MovieService.generateTimeRanges()).then(
          (time_ranges) => {
            let sessionSelections = [];
            let sessionOptions = [];
            let filteredOptions = {
              name: "Shows based on your filters",
              items: [],
            };

            for (let ad in this.availableDates) {
              let sessionsForDate = this.getAvailableSessionsForDate(
                this.availableDates[ad]
              );

              let timestamp = null;
              if (
                this.availableDates[ad].show_time != undefined &&
                this.availableDates[ad].show_time != null
              ) {
                if (
                  this.availableDates[ad].show_time.timestamp != undefined &&
                  this.availableDates[ad].show_time.timestamp != null
                ) {
                  timestamp = this.availableDates[ad].show_time.timestamp;
                }
              }

              let DatesData = {
                name: this.availableDates[ad].string,
                timestamp: timestamp,
                items: [],
              };
              for (let s in sessionsForDate) {
                if (
                  sessionsForDate[s] != undefined &&
                  sessionsForDate[s] != null
                ) {
                  if (
                    sessionsForDate[s].show_time != undefined &&
                    sessionsForDate[s].show_time != null
                  ) {
                    let item = {
                      id: sessionsForDate[s].id,
                      name:
                        sessionsForDate[s].show_time.additional
                          .no_zero_hour_24 +
                        ":" +
                        sessionsForDate[s].show_time.additional.minute +
                        " (" +
                        sessionsForDate[s].screen_name +
                        ")",
                      time_tag: sessionsForDate[s].time_tag,
                    };
                    if (this.selected_time_range) {
                      if (
                        sessionsForDate[s].time_tag != undefined &&
                        sessionsForDate[s].time_tag != null &&
                        typeof sessionsForDate[s].time_tag == "string"
                      ) {
                        if (
                          sessionsForDate[s].time_tag.includes(
                            this.selected_time_range.hour
                          )
                        ) {
                          let filter_item = {
                            id: sessionsForDate[s].id,
                            name:
                              this.availableDates[ad].string +
                              " @ " +
                              sessionsForDate[s].show_time.additional
                                .no_zero_hour_24 +
                              ":" +
                              sessionsForDate[s].show_time.additional.minute +
                              " (" +
                              sessionsForDate[s].screen_name +
                              ")",
                            time_tag: sessionsForDate[s].time_tag,
                          };
                          filteredOptions.items.push(filter_item);
                        } else {
                          DatesData.items.push(item);
                        }
                      }
                    } else {
                      DatesData.items.push(item);
                    }
                  }
                }
              }

              sessionOptions.push(DatesData);
            }

            sessionSelections.push(filteredOptions);
            for (let so in sessionOptions) {
              sessionSelections.push(sessionOptions[so]);
            }

            this.dateAndSessionOptionsForSelect = sessionSelections;
          }
        );
      });
    },

    getAvailableSessionsForDate(date) {
      let sessions = this.sessionsForCinema.filter((session) => {
        if (
          session != undefined &&
          session != null &&
          date != undefined &&
          date != null
        ) {
          if (
            session.show_time != null &&
            session.show_time != undefined &&
            date.show_time != undefined &&
            date.show_time != null
          ) {
            if (
              session.show_time.date != null &&
              session.show_time.date != undefined &&
              date.show_time.date != null &&
              date.show_time != undefined
            ) {
              if (
                session.show_time.date.format("YYYY-MM-DD") ===
                date.show_time.date.format("YYYY-MM-DD")
              ) {
                return true;
              }
            }
          }
        }

        return false;
      });
      // this.matching_time_tags = []
      for (let s in sessions) {
        if (this.selected_time_range) {
          for (let t in this.selected_time_range.ranges) {
            if (
              sessions[s].time_tag != undefined &&
              sessions[s].time_tag != null &&
              typeof sessions[s].time_tag == "string"
            ) {
              if (
                sessions[s].time_tag.includes(
                  this.selected_time_range.ranges[t].hour + ":"
                )
              ) {
                this.matching_time_tags.push(sessions[s].time_tag);
              }
            }
          }
        }
      }

      // this.matching_time_tags = matching_time_tags
      return sessions;
    },

    generateExperienceGroups(experiences) {
      let group_config = [
        {
          name: "2D",
          types: ["2D", "2D Prestige", "2D Kids", "2D DBOX OR 2D"],
        },
        {
          name: "3D",
          types: ["3D", "3D IMAX", "3D Prestige", "3D DBOX OR 3D"],
        },
        {
          name: "IMAX",
          types: ["3D IMAX", "2D IMAX"],
        },
        {
          name: "Prestige",
          types: ["2D Prestige", "3D Prestige"],
        },
        {
          name: "Kids",
          types: ["2D Kids"],
        },
        {
          name: "DBOX",
          types: ["2D DBOX OR DEBOX", "3D DBOX OR 3D"],
        },
        {
          name: "Nouveau",
          types: ["Nouveau", "nouveau", "Nouveau 2D"],
        },
        {
          name: "Subs",
          types: ["2D SUBS", "3D SUBS"],
        },
      ];

      let groups = [];

      for (let gc in group_config) {
        let group = { name: group_config[gc].name, types: [] };
        for (let t in group_config[gc].types) {
          for (let e in experiences) {
            if (experiences[e] != undefined && experiences[e])
              if (experiences[e].name.trim() == group_config[gc].types[t]) {
                group.types.push(experiences[e]);
              }
          }
        }

        let exists = false;
        for (let g in groups) {
          if (groups[g].name == group.name) {
            exists = true;
          }
        }

        if (!exists) {
          groups.push(group);
        }
      }

      this.type_groups = groups;

      if (
        this.$route.params.types &&
        this.$route.params.types != undefined &&
        this.$route.params.types != null
      ) {
        let route_types = this.$route.params.types.split(",");

        for (let g in groups) {
          for (let r in route_types) {
            if (groups[g].name == route_types[r]) {
              this.route_types.push(groups[g]);
            }
          }
        }
      }

      return groups;
    },

    getCinemasForTypes(movies, type_groups) {
      let cinemas = [];
      if (this.movie != null) {
        for (let m in movies) {
          if (movies[m].id == this.movie.id) {
            for (let c in movies[m].cinemas) {
              for (let s in movies[m].cinemas[c]) {
                for (let e in movies[m].cinemas[c][s].experiences) {
                  for (let g in type_groups) {
                    for (let t in type_groups[g].types) {
                      let exists = false;

                      if (
                        movies[m].cinemas[c][s].experiences[e].name !=
                          undefined &&
                        movies[m].cinemas[c][s].experiences[e].name != null &&
                        typeof movies[m].cinemas[c][s].experiences[e].name ==
                          "string"
                      ) {
                        if (
                          type_groups[g].types[t].name ==
                          movies[m].cinemas[c][s].experiences[e].name
                        ) {
                          if (cinemas != undefined && cinemas != null) {
                            if (cinemas.length > 0) {
                              for (let ct in cinemas) {
                                if (
                                  cinemas[ct].id ==
                                  movies[m].cinemas[c][s].cinema.id
                                ) {
                                  exists = true;
                                }
                              }
                            }
                          }

                          if (!exists) {
                            cinemas.push(movies[m].cinemas[c][s].cinema);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        return cinemas;
      }
    },

    regionsForThisMovie(thisMovie, time_ranges) {
      if (thisMovie.cinemas != undefined && thisMovie.cinemas != null) {
        let cinemasForTime = [];
        let cinemasForType = [];
        let cinemas = {};

        for (let c in thisMovie.cinemas) {
          if (
            thisMovie.cinemas[c] != undefined &&
            thisMovie.cinemas[c] != null
          ) {
            for (let s in thisMovie.cinemas[c]) {
              if (
                thisMovie.cinemas[c][s] != undefined &&
                thisMovie.cinemas[c][s] != null
              ) {
                if (
                  this.route_time_range != undefined &&
                  this.route_time_range != null
                ) {
                  if (
                    this.route_time_range.config_ranges != undefined &&
                    this.route_time_range.config_ranges != null
                  ) {
                    for (let cr in this.route_time_range.config_ranges) {
                      if (
                        this.route_time_range.config_ranges[cr] != undefined &&
                        this.route_time_range.config_ranges[cr] != null &&
                        typeof this.route_time_range.config_ranges[cr] ==
                          "string"
                      ) {
                        if (
                          thisMovie.cinemas[c][s].time_tag != undefined &&
                          thisMovie.cinemas[c][s].time_tag != null &&
                          typeof thisMovie.cinemas[c][s].time_tag == "string"
                        ) {
                          if (
                            thisMovie.cinemas[c][s].time_tag.includes(
                              this.route_time_range.config_ranges[cr]
                            )
                          ) {
                            if (
                              this.route_types != undefined &&
                              this.route_types != null &&
                              this.route_types.length > 0
                            ) {
                              for (let rt in this.route_types) {
                                if (
                                  this.route_types[rt] != undefined &&
                                  this.route_types[rt] != null
                                ) {
                                  for (let t in this.route_types[rt].types) {
                                    if (
                                      this.route_types[rt].types[t] !=
                                        undefined &&
                                      this.route_types[rt].types[t] != null
                                    ) {
                                      for (let e in thisMovie.cinemas[c][s]
                                        .experiences) {
                                        if (
                                          thisMovie.cinemas[c][s].experiences[
                                            e
                                          ] != undefined &&
                                          thisMovie.cinemas[c][s].experiences[
                                            e
                                          ] != null
                                        ) {
                                          if (
                                            this.route_types[rt].types[t]
                                              .name ==
                                            thisMovie.cinemas[c][s].experiences[
                                              e
                                            ].name
                                          ) {
                                            cinemas[
                                              thisMovie.cinemas[c][s].cinema.id
                                            ] = thisMovie.cinemas[c][s].cinema;
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            } else {
                              let exists = false;
                              if (
                                cinemasForTime != undefined &&
                                cinemasForTime != null
                              ) {
                                if (cinemasForTime.length > 0) {
                                  for (let cft in cinemasForTime) {
                                    if (
                                      cinemasForTime[cft] != undefined &&
                                      cinemasForTime[cft] != null
                                    ) {
                                      if (
                                        cinemasForTime[cft].id ==
                                        thisMovie.cinemas[c][s].cinema.id
                                      ) {
                                        exists = true;
                                      }
                                    }
                                  }
                                }
                              }

                              if (!exists) {
                                cinemasForTime.push(
                                  thisMovie.cinemas[c][s].cinema
                                );
                                cinemas[thisMovie.cinemas[c][s].cinema.id] =
                                  thisMovie.cinemas[c][s].cinema;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }

                if (this.route_types != undefined && this.route_types != null) {
                  for (let rt in this.route_types) {
                    if (
                      this.route_types[rt] != undefined &&
                      this.route_types[rt] != null
                    ) {
                      for (let t in this.route_types[rt].types) {
                        if (
                          this.route_types[rt].types[t] != undefined &&
                          this.route_types[rt].types[t] != null
                        ) {
                          for (let e in thisMovie.cinemas[c][s].experiences) {
                            if (
                              thisMovie.cinemas[c][s].experiences[e] !=
                                undefined &&
                              thisMovie.cinemas[c][s].experiences[e] != null
                            ) {
                              if (
                                this.route_types[rt].types[t].name ==
                                thisMovie.cinemas[c][s].experiences[e].name
                              ) {
                                cinemas[thisMovie.cinemas[c][s].cinema.id] =
                                  thisMovie.cinemas[c][s].cinema;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        let cinemasFiltered = [];
        for (let oc in cinemas) {
          cinemasFiltered.push(cinemas[oc]);
        }
        this.cinemasForTime = cinemasFiltered;
      }
    },

    compareSessionDates(
      session_show_time,
      selectedDate_show_time,
      second_show_time
    ) {
      return false;
    },

    compareDates(session_show, selected_date) {
      if (session_show != null && selected_date != null) {
        if (
          session_show.format("YYYY-MM-DD") ==
          selected_date.format("YYYY-MM-DD")
        ) {
          return true;
        }
      }

      return false;
    },

    setAppropriateDate(experience, availableDates) {
      let time_range = null;
      let set_date = true;
      if (this.route_time_range != undefined && this.route_time_range != null) {
        if (typeof this.route_time_range == "object") {
          time_range = this.route_time_range;
        }
      }

      let DatetoSet = null;
      for (let ad in availableDates) {
        let sessions = this.getAvailableSessionsForDate(availableDates[ad]);

        if (sessions != undefined && sessions != null) {
          if (sessions.length > 0) {
            for (let s in sessions) {
              //if time range in url
              if (time_range != null) {
                for (let tr in time_range.config_ranges) {
                  if (
                    time_range.config_ranges[tr] != undefined &&
                    time_range.config_ranges[tr] != null &&
                    typeof time_range.config_ranges[tr] == "string"
                  ) {
                    if (
                      sessions[s].time_tag != undefined &&
                      sessions[s].time_tag != null &&
                      typeof sessions[s].time_tag == "string"
                    ) {
                      if (
                        sessions[s].time_tag.includes(
                          time_range.config_ranges[tr]
                        )
                      ) {
                        for (let e in sessions[s].experiences) {
                          if (
                            sessions[s].experiences != null &&
                            sessions[s].experiences != undefined
                          ) {
                            if (typeof sessions[s].experiences == "object") {
                              if (
                                sessions[s].experiences[e].name ==
                                  experience.name &&
                                set_date
                              ) {
                                this.setSelectedDate(
                                  sessions[s].show_time.date
                                );
                                DatetoSet =
                                  sessions[s].show_time.date.format(
                                    "YYYY/MM/DD"
                                  );
                                set_date = false;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                for (let e in sessions[s].experiences) {
                  if (
                    sessions[s].experiences != null &&
                    sessions[s].experiences != undefined
                  ) {
                    if (typeof sessions[s].experiences == "object") {
                      if (
                        sessions[s].experiences[e].name == experience.name &&
                        set_date
                      ) {
                        this.setSelectedDate(sessions[s].show_time.date);
                        DatetoSet = sessions[s].show_time.date;
                        set_date = false;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      return DatetoSet;
    },

    facebookPixelSK(thisMovie) {
      // if(thisMovie.id == "HO00001598" || thisMovie.id == "HO00001606" || thisMovie.id == "HO00001544" || thisMovie.id == "HO00001587") {
      //     !function(f,b,e,v,n,t,s)
      //     {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      //     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      //     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      //     n.queue=[];t=b.createElement(e);t.async=!0;
      //     t.src=v;s=b.getElementsByTagName(e)[0];
      //     s.parentNode.insertBefore(t,s)}(window, document,'script',
      //     'https://connect.facebook.net/en_US/fbevents.js');
      //     fbq('init', '719435408522043');
      //     fbq('track', 'PageView');
      //     this.facebookPixelSKShow = true
      // }
      return false;
    },

    facebookPixelWB(thisMovie) {
      // HO00001598 | HO00001579 | HO00001531
      // if(thisMovie.id == "HO00001579" || thisMovie.id == "HO00001531") {
      //     !function(f,b,e,v,n,t,s)
      //     {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      //     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      //     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      //     n.queue=[];t=b.createElement(e);t.async=!0;
      //     t.src=v;s=b.getElementsByTagName(e)[0];
      //     s.parentNode.insertBefore(t,s)}(window, document,'script',
      //     'https://connect.facebook.net/en_US/fbevents.js');
      //     fbq('init', '492438917984256');
      //     fbq('track', 'PageView');
      //     this.facebookPixelWBShow = true
      // }
      return false;
    },

    facebookPixelStarWars(thisMovie) {
      // if(thisMovie.id == "HO00001533") {
      //     !function(f,b,e,v,n,t,s)
      //     {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      //     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      //     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      //     n.queue=[];t=b.createElement(e);t.async=!0;
      //     t.src=v;s=b.getElementsByTagName(e)[0];
      //     s.parentNode.insertBefore(t,s)}(window, document,'script',
      //     'https://connect.facebook.net/en_US/fbevents.js');
      //     fbq('init', '482871855641247');
      //     fbq('track', 'PageView');
      //     this.facebookPixelSWShow = true
      // }
      return false;
    },

    floodlightBlackWidow(thisMovie) {
      return false;
    },
  },

  watch: {
    formData: {
      handler(n) {
        //default the selected experience
        this.resetForm();
        this.selectedDateSet = null;

        // if(this.sessionData.selectedDate == null) {
        this.first_date_set = false;
        this.second_date_set = false;
        this.setSelectedType = false;
        this.selectedSessionDate = null;
        // }

        if (this.previousCinemaID != n.cinema_id) {
          this.setAppropriateDate();
          // let setExperience = true;
          // if (this.$route.params.experiences) {
          //     // try and find a matching experience in experience for cinemas:
          //     let availableExperiences = this.experiencesForCinemas.filter((e)=>~this.$route.params.experiences.indexOf(e));
          //     if(availableExperiences != null && availableExperiences != undefined) {
          //         if (availableExperiences.length > 0) {
          //             setExperience = false;
          //         }
          //     }

          // }
          // if (setExperience) {
          //     this.formData.experienceName = null
          //     if(this.experiencesForCinemas != undefined && this.experiencesForCinemas != null) {
          //         if(this.experiencesForCinemas.length > 0) {
          //             this.formData.experienceName = {name: this.experiencesForCinemas[0]};
          //             this.setAppropriateDate(this.formData.experienceName)
          //         }
          //     }

          //     this.first_date_set = false
          // }
        }

        this.getDatesForCinemaType();

        this.previousCinemaID = n.cinema_id;
        if (this.formData.cinema != undefined && this.formData.cinema != null) {
          this.formData.cinema_id = this.formData.cinema.id;

          if(this.redirectCinemas.includes(this.formData.cinema_id)) {
            window.location.href="https://movies.sterkinekor.com/actual-content?tab=now-showing"
          }
        }
        if (this.formData.cinema_id) {
          Promise.resolve(
            RegionService.getCinema(this.formData.cinema_id)
          ).then((cinema) => {
            this.selectedCinema = cinema;
          });

          this.selected_cinema_id = this.formData.cinema_id;
          window.scroll({ top: 400, left: 0, behavior: "smooth" });
        }
      },
      deep: true,
    },

    selectedSession: {
      handler(n) {
        if (this.availableDates != undefined && this.availableDates != null) {
          for (let ad in this.availableDates) {
            if (
              this.availableDates[ad] != null &&
              this.availableDates[ad] != undefined
            ) {
              let sessionsForDate = this.getAvailableSessionsForDate(
                this.availableDates[ad]
              );
              if (sessionsForDate != null && sessionsForDate != undefined) {
                for (let s in sessionsForDate) {
                  if (
                    sessionsForDate[s] != undefined &&
                    sessionsForDate[s] != null &&
                    this.selectedSession != null &&
                    this.selectedSession != undefined
                  ) {
                    if (
                      sessionsForDate[s].id != null &&
                      sessionsForDate[s] != undefined &&
                      this.selectedSession.id != null &&
                      this.selectedSession.id != undefined
                    ) {
                      if (sessionsForDate[s].id == this.selectedSession.id) {
                        this.sessionData.selectedSession = sessionsForDate[s];
                        // this.setAppropriateDate(this.formData.experienceName, sessionsForDate[s])
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      deep: true,
    },

    selected_cinema_id: {
      handler(n) {
        this.formData.cinema_id = this.selected_cinema_id;
        this.selectedCinema = RegionService.getCinema(this.selected_cinema_id);
        this.selectedSession = { id: null };
        this.sessionData.selectedSession = {};
        this.gettypesForCinemas();
      },
      deep: true,
    },

    $route(to, from) {
      if (from === "/nouveau") {
        this.$root.$el.classList.add("nouveau");
      } else {
        this.$root.$el.classList.remove("nouveau");
      }
      if (from.name.indexOf("Movie Details") > -1) this.getMovies();
    },
  },

  created () {

    Promise.all([MovieMetaService.getMovieMeta(), RegionService.getRedirectCinemas()]).then(([meta, redirectCinemas]) => {
      let movie_id = this.$route.params.id
      let expired = meta.expired_movies

      this.redirectCinemas = redirectCinemas

      if(expired && expired.length > 0) {
        for(let i = 0; i <= expired.length; i++) {
          if(expired[i] != undefined) {
            if(movie_id == expired[i].field_movie_id) {
              window.location.replace(this.InjectFrontendURL+"/middleware/redirect-url/movies/"+expired[i].field_movie_id);
            }
          }
        }
      }
    })

    Promise.all([
      this.getMovies(),
      MovieService.getMovies(),
      MovieMetaService.getMovieMeta(),
      this.setUser(),
    ]).then(([thisMovie, movies, meta, user]) => {
      Promise.all([
        MovieService.generateTimeRanges(),
        this.generateTimeRanges(movies.data),
        this.generateRangeGroups(),
        MovieService.generateExperienceGroups(meta.experiences),
      ]).then(([time_ranges, mtime, groups, type_groups]) => {
        Promise.all([
          this.setOptionsFromRoute(movies.data, time_ranges),
          this.gettypesForCinemas(),
          this.getDatesForCinemaType(),
        ]).then(([filter_data, types_for_cinemas, dates_for_types]) => {
          if (
            this.$route.params.title == undefined ||
            this.$route.params.title == null
          ) {
            if (
              this.$route.params.festival_id == undefined ||
              this.$route.params.festival_id == null
            ) {
              this.titleSlugSet = false;

              this.$router.push({
                path: this.$route.path + "/" + thisMovie.title_slug,
                redirectParams: { responseCode: 301 },
              });
            }
          } else {
            if (
              this.$route.params.title != undefined &&
              this.$route.params.title != null
            ) {
              this.titleSlugSet = true;
            }
          }

          this.metaExperiences = meta.experiences;
          this.type_groups = type_groups;
          this.timeRanges = time_ranges;
          let first_date_with_time = null;
          let first_date_available = null;
          if (
            this.$route.params.time != undefined &&
            this.$route.params.time != null
          ) {
            for (let t in time_ranges.items) {
              if (
                time_ranges.items[t] != undefined &&
                time_ranges.items[t] != null
              ) {
                if (time_ranges.items[t].id == this.$route.params.time) {
                  this.route_time_range = time_ranges.items[t];
                  let dates = this.dateAndSessionOptionsForSelect;

                  for (let d in dates) {
                    if (dates[d] != undefined && dates[d] != null) {
                      for (let i in dates[d].items) {
                        if (
                          dates[d].items != undefined &&
                          dates[d].items != null
                        ) {
                          if (dates[d].items.length > 0) {
                            for (let cr in this.route_time_range
                              .config_ranges) {
                              if (
                                this.route_time_range.config_ranges[cr] !=
                                  undefined &&
                                this.route_time_range.config_ranges[cr] != null
                              ) {
                                if (
                                  dates[d].items[i].time_tag != undefined &&
                                  dates[d].items[i].time_tag != null &&
                                  typeof dates[d].items[i].time_tag == "string"
                                ) {
                                  if (
                                    dates[d].items[i].time_tag.includes(
                                      this.route_time_range.config_ranges[cr]
                                    )
                                  ) {
                                    if (first_date_with_time == null) {
                                      first_date_with_time = dates[d].timestamp;
                                      first_date_available = dates[d];
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          this.first_date_with_time = first_date_with_time;
          this.first_date_available = first_date_available;

          if (this.$route.params.types && this.type_groups) {
            let groups = this.type_groups;
            let route_types = [];
            if (
              this.$route.params.types != undefined &&
              this.$route.params.types != null
            ) {
              route_types = this.$route.params.types.split(",");

              for (let g in groups) {
                for (let r in route_types) {
                  if (groups[g].name == route_types[r]) {
                    this.route_types.push(groups[g]);
                  }
                }
              }
            }

            Promise.resolve(
              this.getCinemasForTypes(movies.data, this.route_types)
            ).then((type_cinemas) => {
              this.filteredCinemas = type_cinemas;
            });
          }

          this.regionsForThisMovie(thisMovie, time_ranges);

          this.facebookPixelSK(thisMovie);
          this.facebookPixelWB(thisMovie);
          this.facebookPixelStarWars(thisMovie);

          if (this.$route.params.festival_id) {
            PageService.getFilmFestivals().then((festivals) => {
              this.festival = festivals.find(
                (f) => f.nid === this.$route.params.festival_id
              );
              if (this.festival) {
              }
            });
          }

          this.movieCinemas = Object.keys(thisMovie.cinemas);

          //direct order if session id is set
          if (this.$route.params.session_id) {
            for (let c in this.movie.cinemas) {
              for (let s in this.movie.cinemas[c]) {
                if (
                  this.movie.cinemas[c][s].id == this.$route.params.session_id
                ) {
                  let session_id = this.$route.params.session_id;
                  let cinema_id = this.movie.cinemas[c][s].cinema_id;
                  let movie_id = this.$route.params.id;

                  this.startDirectOrder(session_id, cinema_id, movie_id);
                }
              }
            }
          }
        });
      });
    });
  },
  mounted() {
    if (window.__PRERENDER_INJECTED) {
      this.loading = false;
      this.prerender = true;

      if (window.__PRERENDER_INJECTED.movies) {
        let movie_id = this.$route.params.id;
        this.movie_id = movie_id;

        let injected_movies = MovieService.setPreRenderMovies(
          window.__PRERENDER_INJECTED.movies
        );

        let movies = injected_movies;
        this.injected_movies = movies;
        this.movies = movies;
        this.movie = movies.findById(movie_id);

        document.title = this.movie.title + " | Ster-Kinekor";

        this.getAsyncData();
      } else {
        injected_movies = undefined;
        this.injected_movies = injected_movies;
      }

      if (window.__PRERENDER_INJECTED.regions) {
        let injected_regions = RegionService.setPreRenderRegions(
          window.__PRERENDER_INJECTED.regions
        );
        this.injected_regions = injected_regions;
        let regions = injected_regions.data;

        if (!empty(this.movie)) {
          this.regionsRaW = regions.findByCinemas(
            Object.keys(this.movie.cinemas)
          );
        }
      } else {
        injected_regions = undefined;
      }

      if (window.__PRERENDER_INJECTED.cinemas) {
        let injected_cinemas = RegionService.setPreRenderRegionsDictionary(
          window.__PRERENDER_INJECTED.cinemas
        );
        this.injected_cinemas = window.__PRERENDER_INJECTED.cinemas;
      } else {
        injected_cinemas = undefined;
      }

      if (window.__PRERENDER_INJECTED.meta) {
        let injected_meta = MovieMetaService.setPreRenderMovieMeta(
          window.__PRERENDER_INJECTED.meta
        );
        this.injected_meta = injected_meta;

        let meta = injected_meta;

        this.metaExperiences = meta.experiences;

        if (
          meta != undefined &&
          meta != null &&
          meta.experiences != undefined &&
          meta.experiences != null &&
          meta.genres != undefined &&
          meta.genres != null
        ) {
          if (
            this.setTypeOptions(meta.experiences) &&
            this.setGenreOptions(meta.genres)
          ) {
            this.setFormDataFromRoute();
          }
        }
      } else {
        injected_meta = undefined;
        this.injected_meta = undefined;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/details/details.js